import { BaseAPI, type Common } from '../common.js';
import Entity from './entity/index.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type UpdateValues,
  type WorkflowTest,
  type WorkflowTestPopulated,
} from '../models/workflowTest/index.js';

export class API extends BaseAPI {
  Entity: Entity;
  baseEndpoint = '/workflow-test';

  constructor(common: Common) {
    super(common);
    this.Entity = new Entity(common);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<WorkflowTestPopulated>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options: FindAllOptions = {}): Promise<WorkflowTestPopulated[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<WorkflowTest> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(values: UpdateValues): Promise<WorkflowTest> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${values.id}`);
    return await this.common.patchJSON(url, values);
  }
}
